import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

const formSelector = formValueSelector('invite');

const getIsButtonDisabled = state =>
  !formSelector(state, 'email') || !formSelector(state, 'researchId');

const getIsEmailDuplicateMessageVisible = state =>
  state.invites.isEmailDuplicateMessageVisible;

const getIsResearchIdDuplicateMessageVisible = state =>
  state.invites.isResearchIdDuplicateMessageVisible;

const getIsSuccessMessageVisible = state =>
  state.invites.isSuccessMessageVisible;

const getIsLoading = state => state.invites.isFetching;

const getInvite = createSelector(
  getIsButtonDisabled,
  getIsLoading,
  getIsEmailDuplicateMessageVisible,
  getIsResearchIdDuplicateMessageVisible,
  getIsSuccessMessageVisible,
  (
    isButtonDisabled,
    isLoading,
    isEmailDuplicateMessageVisible,
    isResearchIdDuplicateMessageVisible,
    isSuccessMessageVisible
  ) => ({
    isButtonDisabled,
    isLoading,
    isEmailDuplicateMessageVisible,
    isResearchIdDuplicateMessageVisible,
    isSuccessMessageVisible
  })
);

export { getInvite };



// WEBPACK FOOTER //
// ./src/selectors/invite.js